import React, { useEffect, useState } from 'react'
import AppLayout from '../../layout/components/AppLayout'
import userServices from '../userServices';

import { AgGridReact } from 'ag-grid-react';
/*
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
*/

export default function UserRolePage() {

  const [userRoleList,setUserRoleList] = useState(null);

  const getUserRoleList = () =>{
    userServices.getUserRoleList().then((res)=>{
      setUserRoleList(res.data);
    }).catch(error=>{
      console.log(error);
    })
  }

  const [columnDefs] = useState([
    {sortable: true,filter:true, field:"id", },
    {sortable: true,filter:true, field:"title", },
  ])

  useEffect(()=>{
    getUserRoleList();
  },[])

  return (
      <AppLayout>
        <div className="container">
            <div className="row mt-3">
              <div className="col-md-12">
                  <h5 className="float-start">User Role</h5>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-12">
                  {userRoleList && 
                    <div className="ag-theme-alpine" style={{height: 400, width:"auto"}}>
                      <AgGridReact
                          rowData={userRoleList}
                          columnDefs={columnDefs}>
                      </AgGridReact>
                    </div>
                  }
              </div>
            </div>
        </div>
      </AppLayout>
    
  )
}
